import PropTypes from 'prop-types';
import { Button } from "../Button/Button";
import { Dropdown } from "../Dropdown/Dropdown";
import { RadioButtonGroup } from "../RadioButtonGroup/RadioButtonGroup";
import { FilePicker } from "../FilePicker/FilePicker";
import { CheckboxGroup } from "../CheckboxGroup/CheckboxGroup";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
(function () {
  if (typeof document === "undefined") {
    return;
  }
  const styles = ".kof-form {\n  width: 600px;\n  margin-bottom: 8px;\n}\n.kof-form > .row {\n  margin-bottom: 8px;\n}\n.kof-form > .row .element input[type=text],\n.kof-form > .row .element input[type=password],\n.kof-form > .row .element input[type=number],\n.kof-form > .row .element input[type=date] {\n  border: 1px solid #767676;\n  border-radius: 2px;\n  padding: 5px;\n  height: 32px;\n  box-sizing: border-box;\n}\n.kof-form > .row .element input[type=text],\n.kof-form > .row .element input[type=password],\n.kof-form > .row .element input[type=number],\n.kof-form > .row .element input[type=date],\n.kof-form > .row .element select {\n  width: 200px;\n}\n.kof-form > .row .element.textarea {\n  flex-grow: 1;\n}\n.kof-form > .row .element.textarea textarea {\n  padding: 5px;\n  width: 100%;\n  box-sizing: border-box;\n  height: 100px;\n  border: 1px solid #767676;\n  border-radius: 2px;\n}\n.kof-form > .row .element.textarea textarea:hover {\n  border-color: #4f4f4f;\n}\n.kof-form > .row .element input[disabled],\n.kof-form > .row .element select[disabled],\n.kof-form > .row .element textarea[disabled] {\n  opacity: 1;\n  border-color: lightgrey;\n  color: grey;\n  background: #f9f9f9;\n}\n.kof-form > .row .element.filePicker label {\n  padding: 0;\n}\n.kof-form > .row .element.component {\n  flex-grow: 1;\n}\n.kof-form > .row .element.radioButtons .row {\n  margin-bottom: 0;\n}\n.kof-form > .row .element.radioButtons .row label {\n  padding-top: 0;\n  width: initial;\n}\n.kof-form > .row .element .description {\n  color: #65727e;\n  font-size: 13px;\n}\n.kof-form > button {\n  margin-top: 8px;\n}";
  const fileName = "Form_Form_7e4af6e7-9fd4-4540-b552-6f367cdc9f74";
  const element = document.querySelector("style[data-sass-component='Form_Form_7e4af6e7-9fd4-4540-b552-6f367cdc9f74']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const defaultTranslations = {
  submit: 'Submit'
};
function Form(props) {
  const submit = () => props.submit.onSubmit();
  const onKeyDown = (event, element) => {
    const submittableElementTypes = ['text', 'password', 'number'];
    if (event.key === 'Enter' && submittableElementTypes.includes(element.type)) {
      submit();
    }
  };
  const onChange = (elementName, value) => {
    const newValues = Object.assign({}, props.values);
    newValues[elementName] = value;
    props.onChange(newValues);
  };
  const renderElement = (element, value) => {
    if (element.type === 'dropdown') {
      return /*#__PURE__*/_jsx(Dropdown, {
        options: element.options.items,
        value: value,
        id: createElementId(element),
        onChange: newValue => onChange(element.name, newValue),
        disabled: element.disabled,
        ...element.props
      });
    }
    if (element.type === 'radioButtons') {
      return /*#__PURE__*/_jsx(RadioButtonGroup, {
        items: element.options.items,
        value: value,
        onChange: newValue => onChange(element.name, newValue),
        disabled: element.disabled
      });
    }
    if (element.type === 'checkboxes') {
      return /*#__PURE__*/_jsx(CheckboxGroup, {
        items: element.options.items,
        values: value,
        onChange: newValue => onChange(element.name, newValue)
      });
    }
    if (element.type === 'checkbox') {
      return /*#__PURE__*/_jsx("input", {
        type: element.type,
        name: element.name,
        checked: value,
        id: createElementId(element),
        onChange: () => onChange(element.name, !value),
        disabled: element.disabled
      });
    }
    if (element.type === 'filePicker') {
      return /*#__PURE__*/_jsx(FilePicker, {
        label: props.translate('file-picker.choose'),
        fileEndings: element.options.fileEndings,
        files: value,
        onChange: newContent => onChange(element.name, newContent)
      });
    }
    if (element.type === 'textarea') {
      return /*#__PURE__*/_jsx("textarea", {
        name: element.name,
        value: value,
        id: createElementId(element),
        onChange: event => onChange(element.name, event.target.value),
        disabled: element.disabled
      });
    }
    if (element.type === 'component') {
      return element.component;
    }
    return /*#__PURE__*/_jsx("input", {
      type: element.type,
      name: element.name,
      value: value,
      id: createElementId(element),
      onKeyDown: event => onKeyDown(event, element),
      onChange: event => onChange(element.name, event.target.value),
      disabled: element.disabled
    });
  };
  const createElementId = element => {
    return element.name;
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "kof-form",
    children: [props.elements.map(element => {
      const requiredIndicator = element.isRequired ? '*' : null;
      const value = props.values[element.name];
      const description = element.options?.description;
      return /*#__PURE__*/_jsxs("div", {
        className: "row",
        children: [/*#__PURE__*/_jsxs("label", {
          htmlFor: createElementId(element),
          children: [element.label, " ", requiredIndicator]
        }, `label-${element.name}`), /*#__PURE__*/_jsxs("div", {
          className: `element ${element.type}`,
          children: [renderElement(element, value), description && /*#__PURE__*/_jsx("div", {
            className: 'description',
            children: description
          })]
        }, `element-${element.name}`)]
      }, element.name);
    }), props.submit && /*#__PURE__*/_jsx(Button, {
      onClick: submit,
      disabled: props.submit.disabled,
      children: props.submit.label || defaultTranslations.submit
    })]
  });
}
Form.propTypes = {
  elements: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    isRequired: PropTypes.bool,
    options: PropTypes.object,
    props: PropTypes.object
  })).isRequired,
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  submit: PropTypes.shape({
    label: PropTypes.string,
    onSubmit: PropTypes.func,
    disabled: PropTypes.bool
  }),
  translate: PropTypes.func
};
export { Form };